(function adjustCaret() {
  var caret = document.querySelector('img.hero-slide-arrow').parentElement;
  var div = document.querySelector('div.banner-slider #video-trigger .hsContent');
  var clone = caret.cloneNode(true);  
  
  function adjust() {
    if(window.innerWidth < 767) {     
      div.appendChild(clone);
    }
  }

  adjust();
  window.addEventListener('resize', adjust);
})();
